<div class="col-xs-12 footer_container">
  <div class="col-xs-12 container-fluid">
    <div class="row">
      <div class="col-md-4 col-xs-12">

        <div class="d-none d-md-block d-lg-block">
          @if ((logoData | async); as data) {
            <div class="logo_seqirus">
              <img [src]='getImage(data.media)' alt="seqirus" >
            </div>
          }

          <div class="footertermsheaderuk">{{explicitFooterData.h1content}}</div>
          <p class="footerpara-1 footermar" [innerHTML]="explicitFooterData.h2content">{{explicitFooterData.h2content}}</p><br>
          <div [innerHTML]="explicitFooterData.text1"  class="Explictfooter-link"></div><br>
          <div [innerHTML]="explicitFooterData.text2" class="Explictfooter-link"></div>

        </div>
      </div>

      @if ((explicitFooter$ | async); as explicitFooterNode) {
        <div class="col-md-3 col-xs-12 marTop-30 publicFooterAlignment">
          @for (node of explicitFooterNode.children; track node) {
            @if (node.title == 'Website Terms of Use') {
              <div class="footer_headinguk">{{node.title}}</div>
            }
            @if (node.title == 'Website Terms of Use') {
              <ul class="footer_menu_listuk">
                @for (child of node.children; track child) {
                  <!-- <li><a [routerLink]="child.url" target="_blank">{{child.title}}</a></li>
                  <li></li> -->
                  @if (child.title != 'Privacy Policy') {
                    <li><a [routerLink]="child.url" target="_blank">{{child.title}}</a></li>
                  }
                  @if (child.title === 'Privacy Policy') {
                    <li><a [href]="child.url" target="_blank">{{child.title}}</a></li>
                  }
                }
              </ul>
            }
          }
        </div>
      }

    </div>

    <div class="row">
      <div class="col-md-12 footer_txt_disclaimerukconsent">
        <p class="footer_copynote">{{explicitFooterData.notice}}</p>
      </div>
    </div>
  </div>
</div>